import React, { Component } from "react";
import { connect } from "react-redux";
import { finishApplication } from "../../actions";
import PropTypes from "prop-types";
import Frame from "../Frame";
import {createStructuredSelector} from 'reselect';
import {appRequestSelector} from '../../selectors';
import consumer from "../../../../cable";

class ZipContract extends Component {
  handleReceived = (data) => {
    const { finishApplication } = this.props;
    if (data.status) {
      finishApplication();
    }
  };

  componentDidMount() {
    const { appRequest } = this.props;

    consumer.subscriptions.create({
      channel: 'OrderStatusChannel',
      order_id: appRequest.orderId,
    }, {
      connected: () => console.log('connected'),
      disconnected: () => console.log('disconnected'),
      received: data => this.handleReceived(data),
    })
  }

  componentWillUnmount() {
    consumer.disconnect()
  };

  render() {
    const { contractUrl, hidden, appRequest } = this.props;

    return (
      <div>
        <Frame
          contractUrl={contractUrl}
          hidden={hidden}
        />
      </div>
    );
  }
}

ZipContract.propTypes = {
  contractUrl: PropTypes.string,
};

ZipContract.defaultProps = {
  contractUrl: "",
};

const mapStateToProps = createStructuredSelector({
  appRequest: appRequestSelector()
});

const mapDispatchToProps = (dispatch) => ({
  finishApplication: () => dispatch(finishApplication()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZipContract);
